import { HTMLInputTypeAttribute } from "react"
import styled from "styled-components"


interface TextFieldStyles {
  marginBottom: number
}

interface TextFieldProps {
  title?: string,
  type: HTMLInputTypeAttribute|undefined,
  placeholder: string,
  errorMessage?: string,
  value?: string
  onChange?: (text: string) => void
  styles?: TextFieldStyles
  onEnter?: () => void
}

export default function TextFieldView({
  title,
  type,
  placeholder,
  errorMessage,
  value,
  onChange,
  onEnter,
  styles = { marginBottom: 0 },
}: TextFieldProps) {
  return (
    <TextFieldViewDiv
      {...styles}
      enableError={errorMessage !== undefined && errorMessage !== ''}
      className="text_field_view">
      {title && (
        <p className="form_label">{title}</p>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={e => {
          if(onChange) onChange(e.target.value)
        }}
        onKeyDown={e => {
          if(e.key === 'Enter') {
            if(onEnter !== undefined) {
              onEnter()
            }
          }
        }}
        className="outlined_gray"
      />
      {errorMessage !== undefined && <p className="error_msg fs12">{errorMessage}</p>}
    </TextFieldViewDiv>
  )
}

interface StyledProps extends TextFieldStyles {
  enableError: boolean
}

const TextFieldViewDiv = styled.div<StyledProps>`
  margin-bottom: ${props => props.enableError ? props.marginBottom - 18 : props.marginBottom}px;
  position: relative;
  
  input{
    width: 100%;
    height: 46px;
    border-radius: 6px;
  }
  .error_msg{
    color: #ea4335;
    line-height: 14px;
    margin-top: 4px;
    /* position: absolute;
    top: 70px;
    left: 0; */
  }
`